import { render, staticRenderFns } from "./BaseSheetEdit.vue?vue&type=template&id=c8575b4a&scoped=true&"
import script from "./BaseSheetEdit.vue?vue&type=script&lang=ts&"
export * from "./BaseSheetEdit.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSheetEdit.vue?vue&type=style&index=0&id=c8575b4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8575b4a",
  null
  
)

export default component.exports